"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.concatPaths = exports.cleanSlashes = exports.getTopComponent = exports.getTotalOffsetTop = void 0;
function getTotalOffsetTop(element) {
    var yPos = 0;
    while (element) {
        yPos += element.offsetTop;
        element = element.offsetParent;
    }
    return yPos;
}
exports.getTotalOffsetTop = getTotalOffsetTop;
function getTopComponent(components, currentScrollY) {
    var e_1, _a;
    try {
        for (var _b = __values(components.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), index = _d[0], component = _d[1];
            if (!component.ref.current) {
                continue;
            }
            var offset = getTotalOffsetTop(component.ref.current);
            if (offset > currentScrollY) {
                // This component is lower than the top of the page, so let's return the previous one.
                return components[Math.max(index - 1, 0)];
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return components[components.length - 1];
}
exports.getTopComponent = getTopComponent;
function cleanSlashes(path) {
    return "/" + path.replace(/^\/*(.*?)\/*$/, '$1');
}
exports.cleanSlashes = cleanSlashes;
function concatPaths() {
    var e_2, _a;
    var paths = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        paths[_i] = arguments[_i];
    }
    var out = '';
    try {
        for (var paths_1 = __values(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()) {
            var path = paths_1_1.value;
            out = cleanSlashes(out + cleanSlashes(path));
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return out;
}
exports.concatPaths = concatPaths;
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/routables/RoutableContainer/utils/utils.js
// module id = 1000
// module chunks = 8